import { css, Theme, Interpolation } from '@emotion/react'

export const logoContainer: Interpolation<Theme> = css`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const logo: Interpolation<Theme> = css`
  width: 40px;
  height: 40px;
  margin-right: 8px;
`

export const selectedPlatformBlock: Interpolation<Theme> = css`
  display: flex;
  flex-direction: column;
  user-select: none;
`

export const selectedPlatformTitle: Interpolation<Theme> = (theme) => css`
  font-weight: 700;
  font-size: 18px;
  line-height: 23px;
  color: ${theme.typographyColors.typographyTwo};
`

export const selectedPlatformDescription: Interpolation<Theme> = (theme) => css`
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  color: ${theme.typographyColors.typographyThree};
  margin-right: -20px;
`

export const productsSelector: (isOpen: boolean) => Interpolation<Theme> = (isOpen) => (theme) =>
  css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 12px 9px;
    box-sizing: border-box;
    color: ${theme.typographyColors.typographyThree};
    background-color: transparent;
    border-radius: 12px;
    cursor: pointer;

    &:hover {
      background-color: ${theme.backgrounds.backgroundThree};
    }

    ${isOpen &&
    css`
      background-color: ${theme.backgrounds.backgroundThree};
    `}
  `

export const platformsInnerWrapper: Interpolation<Theme> = css`
  padding-top: 16px;
`
